<ng-container [ngSwitch]="context ? context.type : ''">
    <fui-edit-switch-input [disabled]="disabled" #input [label]="label" [(ngModel)]="value"
                           (focussed$)="onFocussed($event)" *ngSwitchDefault></fui-edit-switch-input>
    <fui-filter-switch-input (focussed$)="onFocussed($event)" *ngSwitchCase="contextType.FILTER"></fui-filter-switch-input>
    <fui-inline-switch-input (focussed$)="onFocussed($event)" *ngSwitchCase="contextType.INLINE"></fui-inline-switch-input>
    <fui-checkbox-pill (focussed$)="onFocussed($event)" *ngSwitchCase="contextType.PILL"></fui-checkbox-pill>
    <fui-pop-switch-input (focussed$)="onFocussed($event)" *ngSwitchCase="contextType.POP"></fui-pop-switch-input>
</ng-container>
